<template>
  <font-awesome-icon
    :icon="['fas', 'chevron-down']"
    class="transform duration-300"
    :class="{
      'rotate-180': dir,
    }"
  />
</template>

<script>
export default {
  props: {
    dir: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
